var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.884,
    cy: 16.839,
    r: 16.5,
    fill: "#F1F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#214ba5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.384 24.006h-8V10.672h8v1.333h1.333v-2a.667.667 0 0 0-.666-.666h-9.334a.667.667 0 0 0-.666.666v14.667c0 .368.298.667.666.667h9.334a.667.667 0 0 0 .666-.667v-2h-1.333v1.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.718 17.339-4.667-4v3.333h-4.667v1.334h4.667v3.333l4.667-4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.384 9.339)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.12ccf7f1a4b737b52c231c20d5f5e173.svg";
export { ForwardRef as ReactComponent };